// Пункты меню пульта (задача D5): разделы из `ROUTES` (D4) в их порядке, только открытые роли вошедшего — закрытые
// разделы в меню не показываются (ui-spec §2), по прямой ссылке их встречает «Нет доступа».
import type { Role } from '@contract/index.js';
import type { LucideIcon } from 'lucide-react';
import { ROUTES, type SectionId, type SectionRoute } from '@/app/routes';

export interface NavItem {
  readonly id: SectionId;
  readonly href: string;
  readonly titleRu: string;
  readonly icon: LucideIcon;
  /**
   * Счётчик справа от пункта (`text-sm`, muted): ключ данных, откуда его брать. Подключит D18 — «На проверку» из
   * счётчиков очередей; пока счётчиков нет.
   */
  readonly countKey?: 'review';
}

function isSection(route: (typeof ROUTES)[number]): route is SectionRoute {
  return route.id !== 'login';
}

/** Пункты меню для роли, в порядке `ROUTES`. */
export function navItems(role: Role): NavItem[] {
  return ROUTES.filter(isSection)
    .filter((route) => route.roles.includes(role))
    .map(({ id, href, titleRu, icon }) => ({ id, href, titleRu, icon }));
}

/** Пункт активен: тот же путь или путь внутри раздела. «Обзор» (`/`) — только сам корень. */
export function isActiveHref(href: string, pathname: string): boolean {
  if (href === '/') return pathname === '/';
  return pathname === href || pathname.startsWith(`${href}/`);
}

/** Инициалы для кружка пользователя: «Влад Тестов» → «ВТ». */
export function initialsOf(name: string): string {
  const letters = name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase());
  return letters.join('') || '?';
}
